class DashboardController
{

  constructor (
    $translate,
    $state,
    $q,
    authService,
    courseService,
    helperService
  )
  {
    'ngInject';

    this.sectionTitle = '';
    this.showUnit = '';

    Object.assign( this, {
      $translate,
      $state,
      $q,
      authService,
      courseService,
      helperService
    } );

    this.loading = true;
    this.showIntroductionPopup = false
    this.showTestDrivePopup = false
  }

  $onInit ()
  {
    this.isJustRegistered = this.$state.isJustRegistered || false
    this.userFirstName = ', ' + this.$state.userFirstName || ''
    this.user = this.authService.getUser();
    this.getCourses(); 
  }

  onClosePopup ( { name } )
  {
    switch ( name )
    {
      case 'introduction-popup':
        this.showIntroductionPopup = false
        break
      case 'test-drive-popup':
        this.showTestDrivePopup = false
    }
  }

  getCourses ()
  {
    this.$q.all( [ this.courseService.getAll(), this.courseService.getProgress() ] )
      .then( data =>
      {
        this.course = data[ 0 ][ 0 ];
        this.userProgress = data[ 1 ];
        // this.calculateProgress();
        this.loading = false;
      } );
  }

  calculateProgress ()
  {
    let totalCount = 0;
    let compleated = 0;

    this.course.sections.forEach( section =>
    {
      totalCount += section.units.length;
      section.units.forEach( ( unit, i ) =>
      {

        if ( unit.completed )
        {
          compleated++;
        }

        if ( i > 0 && section.units[ i - 1 ].id === this.userProgress.unit_id )
        {
          this.activeUnit = unit;
        }

      }, 0 );
    } );

    if ( !this.activeUnit )
    {
      this.activeUnit = this.course.sections[ 0 ];
    }

    const count = Math.ceil( compleated * 100 / totalCount );
    this.progress = this.$translate.instant( 'dashboard.progress', { count } );
    // this.activeUnitTitle = this.$translate.instant(`course.unit.${this.activeUnit.name}`, { name: this.activeUnit.name.title });
    this.activeUnitTitle = this.activeUnit.name;
  }

  unitMouseEnter ( unitTitle )
  {
    this.sectionTitle = unitTitle;
    this.showUnit = unitTitle;
  }

  unitMouseLeave ()
  {
    this.sectionTitle = '';
    this.showUnit = '';
  }

  logout ()
  {
    this.authService.logOut();
  }
}

export default DashboardController;



// WEBPACK FOOTER //
// ./client/app/modules/dashboard/dashboard.controller.js